import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAccessAuthorizationHeaders } from "../../../../api";
import { helpers } from "../../../../packages/helpers";
import { authSelectors } from "../../../auth";
import { EVENT_TYPES } from "../../../sse";
import { selectChatId } from "../../selectors";
import { CHAT_ACTIONS } from "../../types";
import type { ActionStoreParams } from "../../../../store";
import type { PostEventData, PostEventApiCallback } from "../../types";

const { selectUserId } = authSelectors;
const { getActionErrorText } = helpers.error;

type ActionParams = {
  postEventApi: PostEventApiCallback;
};

export const postEventUserTyping = createAsyncThunk<
  void,
  ActionParams,
  ActionStoreParams
>(
  CHAT_ACTIONS.POST_EVENT_USER_TYPING,
  async ({ postEventApi }, { getState }) => {
    const state = getState();
    const chatId = selectChatId(state);
    const userId = selectUserId(state);
    const type = EVENT_TYPES.TYPING_NOTIFICATION;
    const content = { userId: Number(userId) };
    const data: PostEventData = { type, content };

    try {
      const headers = getAccessAuthorizationHeaders(getState());

      await postEventApi(chatId, data, { headers });
    } catch (e) {
      const text = getActionErrorText(e);

      throw new Error(text);
    }
  }
);
